import { Stack, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ButtonsPrimary } from '../../ComponentApp/buttoms';
import {
  BtnContainer,
  IconsWarnning,
  ModalContainer,
  MsnAlert,
  MuntCashContiner,
  MuntContainer,
  MuntContext,
  MuntContextRescue,
  ParrafoAlert,
  TextImportante,
  TitleAlert,
  ValueMunt,
  ValueMuntRescue,
  WarningAmber,
} from '../../products/rescueFund/ReceivedRescueFunds';
import { RescueContentPortfolio } from './RescueComponent';

const ReceivedRescuePortfolio = ({ rescueAmount = '', days = '12', date = '12' }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <>
      <Stack
        sx={{
          width: '100%',
          maxWidth: '1200px',
          margin: '0 auto',
          alignItems: 'center',
          mb: '25px',
        }}>
        <RescueContentPortfolio
          width={{ md: '100%', sx: '80%' }}
          height={{ md: 'auto', sx: 'auto' }}
          minWidth={{ md: '740px', sx: '' }}
          mb={9}>
          <ModalContainer>
            <Stack direction={'row'} alignItems={'center'} alignSelf={'center'}>
              <Stack width={{ xs: '60px', sm: '70px' }} height={{ xs: '60px', sm: '70px' }}>
                <img
                  src='/assets/images/sucess-gif.gif'
                  alt='success'
                  style={{ width: '100%', height: '100%', display: 'block' }}
                />
              </Stack>
              <Typography
                sx={{
                  color: theme.palette.secondary.main,
                  fontWeight: theme.typography.button.fontWeight,
                  fontSize: {
                    xs: '1rem',
                    sm: '1.3rem',
                  },
                }}>
                ¡Hemos recibido tu solicitud!
              </Typography>
            </Stack>

            <MuntCashContiner>
              <MuntContainer>
                <MuntContextRescue
                  sx={{
                    fontSize: theme.typography.mediumText.fontSize,
                    fontWeight: theme.typography.littleText.fontWeight,
                    [theme.breakpoints.down('sm')]: {
                      fontSize: theme.typography.customButton.fontSize,
                    },
                  }}>
                  Monto solicitado
                </MuntContextRescue>
                <ValueMuntRescue
                  sx={{
                    fontSize: theme.typography.mediumText.fontSize,
                    fontWeight: theme.typography.button.fontWeight,
                    [theme.breakpoints.down('sm')]: {
                      fontSize: theme.typography.customButton.fontSize,
                    },
                  }}>
                  $ {rescueAmount}
                </ValueMuntRescue>
              </MuntContainer>
            </MuntCashContiner>

            <MuntCashContiner sx={{ background: theme.palette.white.main }}>
              <MuntContainer sx={{ marginTop: 2 }}>
                <MuntContext
                  sx={{
                    fontWeight: theme.typography.smallText.fontWeight,
                    color: theme.palette.primary.dark,
                  }}>
                  Plazo de rescate:
                </MuntContext>
                <ValueMunt
                  sx={{
                    fontSize: theme.typography.mediumText.fontSize,
                    [theme.breakpoints.down('sm')]: {
                      fontSize: theme.typography.customButton.fontSize,
                    },
                    color: theme.palette.primary.dark,
                  }}>
                  {days}
                </ValueMunt>
              </MuntContainer>
              <MuntContainer sx={{ marginTop: 4 }}>
                <MuntContext
                  sx={{
                    fontWeight: theme.typography.smallText.fontWeight,
                    color: theme.palette.primary.dark,
                  }}>
                  Fecha y hora de solicitud:
                </MuntContext>
                <ValueMunt
                  sx={{
                    fontSize: theme.typography.mediumText.fontSize,
                    [theme.breakpoints.down('sm')]: {
                      fontSize: theme.typography.customButton.fontSize,
                    },
                    color: theme.palette.primary.dark,
                  }}>
                  {date}
                </ValueMunt>
              </MuntContainer>
            </MuntCashContiner>

            <MsnAlert sx={{ marginTop: 3, marginBottom: 3 }}>
              <TitleAlert>
                <WarningAmber>
                  <IconsWarnning />
                </WarningAmber>
                <TextImportante>Importante</TextImportante>
              </TitleAlert>
              <ParrafoAlert
                sx={{
                  width: '100%',
                  margin: '0 auto',
                  [theme.breakpoints.down('sm')]: {
                    textAlign: 'center',
                  },
                }}>
                Te informaremos por correo cuando el rescate esté disponible en tu caja.
              </ParrafoAlert>
            </MsnAlert>
            <BtnContainer
              gap={2}
              mt={50}
              sx={{
                flexDirection: { xs: 'column', md: 'row' },
              }}>
              <ButtonsPrimary
                name='Volver al inicio'
                disableElevation
                onClick={() => navigate('/myprofilerisk')}
                sx={{ md: '55%' }}
              />
            </BtnContainer>
          </ModalContainer>
        </RescueContentPortfolio>
      </Stack>
    </>
  );
};

export default ReceivedRescuePortfolio;
